<app-table-pagination-layout
  [isLoading]="isLoading"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [length]="count"
  (paginationFilter)="getPaginationFilter($event)"
>
  <ng-container table-item>
    <app-table
      [titleIcon]="'message'"
      [title]="'DASHBOARD.MESSAGES.HEADER' | translate"
      [tableData]="tableData"
      [buttons]="tableButtons"
      [tableColumns]="tableColumns"
      [tableConfigurations]="tableConfigs"
      [customCellTemplate]="cellTemplate"
      (rowActionData)="onActionClicked($event)"
    >
      <ng-container filters-table>
        <app-contact-us-messages-filters (filterChanged)="getFilterData($event)"></app-contact-us-messages-filters>
      </ng-container>

      <ng-template #cellTemplate let-item let-dataKey="dataKey">
        <!-- format date cell in table -->
        <ng-container *ngIf="dataKey == 'createdAt'">
          <span>{{item.createdAt | dateFormatter }}</span>
        </ng-container>

        <ng-container *ngIf="dataKey == 'user.userId'">
          <span>{{item.userType === UserType.STUDENT ? item.user.userId : item.user.id}}</span>
        </ng-container>

        <!-- format user type cell in table -->
        <ng-container *ngIf="dataKey == 'userType'">
          <span>{{ "ENUMS.USER_TYPES."+item.userType | translate }}</span>
        </ng-container>
      </ng-template>
    </app-table>
  </ng-container>
</app-table-pagination-layout>

<ng-template #popup let-caller let-data="data" let-dialog="dialogRef">
  <app-contact-us-popup [initializeCaller]="caller" [matDialogRef]="dialog" [message]="data"></app-contact-us-popup>
</ng-template>
